import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../loader-service/loader.service';
import { delay, finalize, map, Observable, of, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MasterDataInboundService {
  baseUrl = environment.baseUrl;
  private supplierApiUrl = environment.baseUrl + 'v1/epcis/supplier';
  private apiUrl = environment.baseUrl + "v1/updateData";

  constructor(public http: HttpClient, public loaderService: LoaderService) {}

  fetchInboundMasterData(numberPerPage: number, pageIndex: number): Observable<any> {
    const requestBody = {
      requestType: "records",
      page: pageIndex,
      numberPerPage: numberPerPage,
    };

    this.loaderService.show();
    return this.getInboundMasterData(requestBody);
  }

  onPageSizeChangeInMasterDataInbound(requestBody: any): Observable<any> {
    this.loaderService.show();
    return this.getInboundMasterData(requestBody);
  }

  private getInboundMasterData(requestBody: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'v1/epcis/records/inboundmaster/getAll', requestBody).pipe(
      map(response => {
        const data = Array.isArray(response?.data) ? response.data : [];
        return {
          data,
          columns: data.length > 0 ? Object.keys(data[0]) : [],
          total: response?.total ?? 0
        };
      }),
      finalize(() => {
        of(null).pipe(delay(500)).subscribe(() => {
          this.loaderService.hide();
        });
      })
    );
  }

  deleteRecord(uuid: string): Observable<any> {
    const url = `${this.baseUrl}v1/epcis/records/inboundmasterdelete/${uuid}`;
    return this.http.delete(url);
  }

  updateMasterdataInboundRecord(uid: string, updatePayload: any): Observable<any> {
    const url = `${this.supplierApiUrl}/${uid}`;
    return this.http.put<any>(url, updatePayload);
  }

  updateEnableDisableState(uuid: string, enableEmailNotification: boolean, entity: string, gln: string, code: string): Observable<any> {
    const payload = { enableEmailNotification, entity, gln, code };
    return this.http.put<any>(`${this.supplierApiUrl}/${uuid}`, payload);
  }

  updateEpcisValidatorState(uuid: string, enabledEpcisValidator: boolean, entity: string, gln: string, code: string): Observable<any> {
    const payload = { enabledEpcisValidator, entity, gln, code };
    return this.http.put<any>(`${this.supplierApiUrl}/${uuid}`, payload);
  }

  addMasterDataInboundRecord(payload: any): Observable<any> {
    return this.http.post<any>(this.supplierApiUrl, payload);
  }

  columnFilterDebounceAction(requestBody: any): Observable<any> {
    const finalRequestBody = { ...requestBody, page: 0, numberPerPage: 5000 };
    this.loaderService.show();
    
    return this.http.post<any>(this.baseUrl + 'v1/epcis/records/inboundmaster/unique', finalRequestBody).pipe(
      map((records: { status: number | string; total: number; uniqueData: Array<{ [key: string]: Array<any> }> }) => {
        return records;
      }),
      finalize(() => {
        of(null).pipe(delay(500)).subscribe(() => {
          this.loaderService.hide();
        });
      })
    );
  }

}